<template>
	<div>
		<p v-if="$tera.project.TrialWizard.isCommittee">
			{{
				selectRandom([
					"To monitor the progress of the study, a data monitoring committee (DMC) was set up at the initiation of the study to",
					"A data monitoring committee (DMC) was formed at the start of the project 'to monitor the progress of the study to' ",
					"In order to oversee the progress of the study, a data monitoring committee (DMC) was established at the beginning of the study to ",
					"A data monitoring committee (DMC) was formed at the start of the project 'to monitor the progress of the study to' "
				])
			}}
			{{
				$tera.project.TrialWizard.committeeDetails
					? $tera.project.TrialWizard.committeeDetails
					: "BLANK"
			}}.
			{{
				$tera.project.TrialWizard.committeeReporting
					? capitalize($tera.project.TrialWizard.committeeReporting)
					: "BLANK"
			}}.
			{{ selectRandom(["The committee comprised"]) }}
			{{
				$tera.project.TrialWizard.committeeComposition
					? $tera.project.TrialWizard.committeeComposition
					: "BLANK"
			}}.
			{{ selectRandom(["Further details can be found at"]) }}
			{{
				$tera.project.TrialWizard.committeeLink
					? $tera.project.TrialWizard.committeeLink
					: "BLANK"
			}}.
		</p>

		<p v-if="!$tera.project.TrialWizard.isCommittee">
			{{
				selectRandom([
					"A data monitoring committee (DMC) will not be set up for this study because",
					"This study will not establish a data monitoring committee (DMC) because",
					"A data monitoring committee (DMC) will not be established for this study due to the following reasons: ",
					"A data monitoring committee (DMC) will not be established for this study due to "
				])
			}}
			{{
				$tera.project.TrialWizard.committeeNotSetUpReasons
					? $tera.project.TrialWizard.committeeNotSetUpReasons
					: "BLANK"
			}}.
		</p>

		<p v-if="$tera.project.TrialWizard.isInterimAnalysis">
			{{
				selectRandom([
					"Interim analysis was planned to be conducted at",
					"An interim analysis was scheduled to take place at",
					"Interim analysis was scheduled to be done at",
					" We are going to schedule the interim analysis at"
				])
			}}
			{{
				$tera.project.TrialWizard.interimAnalysisTimePoints
					? $tera.project.TrialWizard.interimAnalysisTimePoints
					: "BLANK"
			}}.
			{{
				selectRandom([
					"Results from the interim analysis will be made available to the",
					"The interim analysis results will be made available to the ",
					"Interim analysis results will be provided to the ",
					"Interim analysis results will be available at the "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.committeeNotSetUpReasons)
				)
			}}.
			{{ selectRandom(["The study could be stopped if"]) }}
			{{
				$tera.project.TrialWizard.earlyStop
					? $tera.project.TrialWizard.earlyStop
					: "BLANK"
			}}.
			{{
				selectRandom([
					"A final decision on terminating the study will be made by the",
					"The decision regarding the study's termination will be made by the ",
					"The decision to end the research will be decided by the ",
					"The decision to end the research will be taken by the"
				])
			}}
			{{
				joinArrayWithOr(
					formatSelectMulti($tera.project.TrialWizard.finalDecisionOnTermination)
				)
			}}.
		</p>

		<p v-if="!$tera.project.TrialWizard.isInterimAnalysis">
			{{
				selectRandom([
					"Interim analysis are not planned because",
					"No interim analysis are planned because",
					"There is no interim analysis planned because",
					"We are not planning an interim analysis because"
				])
			}}
			{{
				$tera.project.TrialWizard.interimNotConductedReasons
					? $tera.project.TrialWizard.interimNotConductedReasons
					: "BLANK"
			}}.
		</p>

		<p>
			{{
				selectRandom([
					"Adverse events will be monitored",
					"Monitoring of adverse events",
					"Adverse reactions will be monitored",
					"Observation of adverse events"
				])
			}}
			{{
				$tera.project.TrialWizard.adverseEventsMonitored
					? $tera.project.TrialWizard.adverseEventsMonitored
					: "BLANK"
			}}.
		</p>

		<p>
			{{
				selectRandom([
					"Trial auditing will be planned",
					"Planning of trial audits",
					"Trial audits are planned",
					"Recording of the trial is planned"
				])
			}}
			{{
				$tera.project.TrialWizard.trialAuditing
					? $tera.project.TrialWizard.trialAuditing
					: "BLANK"
			}}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputMonitoring",
	mixins: [OutputMixin]
};
</script>
